unit UHolidayNewForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UStampModel,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, Types, Vcl.Grids,
  WEBLib.Grids, UMainConfig, UAbwList, UHolidayModel, WEBLib.Buttons;

type
  THolidayNewForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    pnlStatus: TPanel;
    sgStatus: TStringGrid;
    pnlStatistic: TPanel;
    sgStatistic: TStringGrid;
    pnlData: TPanel;
    WebLabel1: TLabel;
    cbbAbw: TComboBox;
    dtpVon: TDateTimePicker;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    dtpBis: TDateTimePicker;
    WebLabel4: TLabel;
    memReason: TMemo;
    btnSend: TBitBtn;
    procedure WebFormResize(Sender: TObject);
    procedure btnBackClick(Sender: TObject);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
    procedure dtpVonChange(Sender: TObject);
    procedure dtpBisChange(Sender: TObject);
    procedure memReasonChange(Sender: TObject);
    procedure btnSendClick(Sender: TObject);
    procedure cbbAbwChange(Sender: TObject);
  private
    FMainConfig: TMainConfig;
    FAbwList: TAbwList;
    FHoliday: THolidayModel;
    FFakStamp: TStampModel;
    FStamp: TStampModel;
    function CheckMask: Boolean;
    procedure AfterCheckAppForLeave(Sender: TObject);
    procedure AfterGetErrorMessage(Sender: TObject);
    procedure AfterInsertAppForLeave(Sender: TObject);
    procedure cbbAbwFill;
    procedure GetMask;
    procedure GetLastFakStamp;
    procedure GetRestUrlaubVorjahr;
    procedure GetStatus;
    procedure GetUrlaubsanspruchLfdJahr;
    procedure GetUrlaubGnommen;
    procedure GetUrlaubAusbezahlt;
    procedure GetResturlaub;
    procedure GetUrlaubGeplant;
    procedure GetUrlaubPlanbar;
    procedure sgStatisticInit;
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetMask;
    procedure SetAbwList(const Value: TAbwList);
    procedure SetHoliday(const Value: THolidayModel);
    procedure SetFakStamp(const Value: TStampModel);
    procedure SetStamp(const Value: TStampModel);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property AbwList: TAbwList read FAbwList write SetAbwList;
    property Holiday: THolidayModel read FHoliday write SetHoliday;
    property Stamp: TStampModel read FStamp write SetStamp;
    property FakStamp: TStampModel read FFakStamp write SetFakStamp;
  protected procedure LoadDFMValues; override; end;

var
  HolidayNewForm: THolidayNewForm;

implementation

uses
  UEssentialHelper, UGridHelper, System.DateUtils;

{$R *.dfm}

procedure THolidayNewForm.sgStatisticInit;
var
  i, defaultColWidth: Integer;
begin
  sgStatistic.ColCount := 8;
  sgStatistic.RowCount := 2;
  sgStatistic.FixedCols := 0;
  sgStatistic.FixedRows := 1;
  sgStatistic.Cells[0, 0] := '';
  sgStatistic.Cells[1, 0] := Bold('Resturlaub Vorjahr');
  sgStatistic.Cells[2, 0] := Bold('Urlaubsanspruch lfd. Jahr');
  sgStatistic.Cells[3, 0] := Bold('Urlaub genommen');
  sgStatistic.Cells[4, 0] := Bold('ausbezahlter Urlaub');
  sgStatistic.Cells[5, 0] := Bold('Resturlaub');
  sgStatistic.Cells[6, 0] := Bold('geplaner Urlaub');
  sgStatistic.Cells[7, 0] := Bold('planbarer Urlaub');
  sgStatistic.Cells[0, 1] := '';
  sgStatistic.ColWidths[0] := 5;
  defaultColWidth := (sgStatistic.ClientWidth - sgStatistic.ColWidths[0] -
    24) div 7;
  for i := 1 to sgStatistic.ColCount - 1 do
    sgStatistic.ColWidths[i] := defaultColWidth;
  Self.GetRestUrlaubVorjahr;
  Self.GetUrlaubsanspruchLfdJahr;
  Self.GetUrlaubGnommen;
  Self.GetUrlaubAusbezahlt;
  Self.GetResturlaub;
  Self.GetUrlaubGeplant;
  Self.GetUrlaubPlanbar;
end;

procedure THolidayNewForm.AfterCheckAppForLeave(Sender: TObject);
begin
  if Self.Holiday.Ergebnis = '5' then
    dtpVon.Date := Self.Holiday.Von;
  if Self.Holiday.Ergebnis = '6' then
    dtpBis.Date := Self.Holiday.Bis;
  if (Self.Holiday.Ergebnis = '0') then
  begin
    Self.Holiday.OnPropertyChanged := AfterInsertAppForLeave;
    Self.Holiday.InsertAppForLeave(Self.MainConfig.uri,
      Self.MainConfig.User.PersonalNr);
  end
  else
  begin
    Self.Holiday.OnPropertyChanged := AfterGetErrorMessage;
    Self.Holiday.GetErrorMessage(Self.MainConfig.uri,
      StrToInt(Self.Holiday.Ergebnis));
  end;
end;

procedure THolidayNewForm.AfterGetErrorMessage(Sender: TObject);
begin
  MessageDLG(Self.Holiday.Ergebnis, mtWarning, [mbOK]);
end;

procedure THolidayNewForm.AfterInsertAppForLeave(Sender: TObject);
begin
  if Self.Holiday.Ergebnis <> '' then
    MessageDLG(Self.Holiday.Ergebnis, mtInformation, [mbOK]);
  Self.btnBackClick(Sender);
end;

procedure THolidayNewForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure THolidayNewForm.btnSendClick(Sender: TObject);
  procedure ResultProc(AValue: TModalResult);
  begin
    if AValue = mrYes then
    begin
      Self.Holiday.OnPropertyChanged := AfterCheckAppForLeave;
      Self.Holiday.CheckAppForLeave(Self.MainConfig.uri,
        Self.MainConfig.User.PersonalNr);
    end;
  end;

begin
  Self.MainConfig.TimerReset;
  if Self.CheckMask then
  begin
    Self.GetMask;
    if Self.MainConfig.AppForLeaveConfig.Confirmation then
      MessageDLG('Antrag jetzt abschicken?', mtConfirmation, [mbYes, mbNo],
        @ResultProc)
    else
      ResultProc(mrYes);
  end;
end;

procedure THolidayNewForm.cbbAbwChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
end;

procedure THolidayNewForm.cbbAbwFill;
  procedure Callback(Sender: TObject);
  var
    i: Integer;
  begin
    cbbAbw.Items.Clear;
    if Sender is TAbwList then
    begin
      Self.AbwList := Sender as TAbwList;
      for i := 0 to Self.AbwList.Count - 1 do
        cbbAbw.Items.Add(Self.AbwList.Items[i].Bezeichnung);
      Self.SetMask;
    end;
  end;

begin
  if Self.AbwList = nil then
    Self.AbwList := TAbwList.Create;
  Self.AbwList.OnPropertyChanged := Callback;
  Self.AbwList.GetAll(Self.MainConfig.uri);
end;

function THolidayNewForm.CheckMask: Boolean;
var
  error: string;
begin
  error := '';
  if (error = '') and (cbbAbw.ItemIndex = -1) then
  begin
    error := 'Es muss ein Abwesenheit gewählt werden!';
    cbbAbw.SetFocus;
  end;
  if (error = '') and (dtpVon.Date < Date + 1) then
  begin
    error := 'Das Startdatum der Abwesenheit liegt in der Vergangheit!';
    dtpVon.SetFocus;
  end;
  if (error = '') and (dtpVon.Date > dtpBis.Date) then
  begin
    error := 'Das Ende der Abwesenheit liegt vor dem Startdatum!';
    dtpBis.SetFocus;
  end;
  if error <> '' then
    MessageDLG(error, mtWarning, [mbOK]);
  Result := error = '';
end;

procedure THolidayNewForm.dtpBisChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if dtpBis.Date < dtpVon.Date then
    dtpBis.Date := dtpVon.Date;
end;

procedure THolidayNewForm.dtpVonChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if dtpVon.Date <= Date then
    dtpVon.DateTime := Date + 1;
  if dtpBis.Date < dtpVon.Date then
    dtpBis.Date := dtpVon.Date;
end;

procedure THolidayNewForm.GetLastFakStamp;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.FakStamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastFakStamp(Self.MainConfig.uri);
end;

procedure THolidayNewForm.GetMask;
var
  index: Integer;
  helper: string;
begin
  index := Self.AbwList.IndexOf(cbbAbw.Text);
  if index = -1 then
    raise Exception.Create
      ('Abwesenheit ''+cbbAbw.Text+'' in Liste nicht gefunden!');
  Self.Holiday.Abw := Self.AbwList.Items[index];
  Self.Holiday.Von := dtpVon.Date;
  Self.Holiday.Bis := dtpBis.Date;
  helper := memReason.Lines.Text;
  helper := StringReplace(helper, #10, ' ', [rfReplaceAll]);
  Self.Holiday.Grund := helper;
end;

procedure THolidayNewForm.GetResturlaub;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[5, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[5, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetResturlaub(Self.MainConfig.uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaResturlaubId, YearOf(now));
end;

procedure THolidayNewForm.GetRestUrlaubVorjahr;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[1, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[1, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetResturlaub(Self.MainConfig.uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaResturlaubId, YearOf(now) - 1);
end;

procedure THolidayNewForm.GetStatus;
var
  st: TStampModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is TStampModel then
    begin
      Self.Stamp:=Sender as TStampModel;
      Self.WebFormResize(nil);
    end;
  end;

begin
  st := TStampModel.Create;
  st.PersonalNr := Self.MainConfig.User.PersonalNr;
  st.OnPropertyChanged := Callback;
  st.GetLastStamp(Self.MainConfig.uri);
end;

procedure THolidayNewForm.GetUrlaubAusbezahlt;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[4, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[4, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetUrlaubAusbezahlt(Self.MainConfig.uri,
    Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaResturlaubId, YearOf(now));
end;

procedure THolidayNewForm.GetUrlaubGeplant;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[6, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[6, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetUrlaubGeplant(Self.MainConfig.uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaUrlaubId);
end;

procedure THolidayNewForm.GetUrlaubGnommen;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[3, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[3, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetUrlaubGenommen(Self.MainConfig.uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaResturlaubId, YearOf(now));
end;

procedure THolidayNewForm.GetUrlaubPlanbar;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[7, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[7, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetUrlaubPlanbar(Self.MainConfig.uri, Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaResturlaubId,
    Self.MainConfig.AppForLeaveConfig.ZaUrlaubId, YearOf(now));
end;

procedure THolidayNewForm.GetUrlaubsanspruchLfdJahr;
var
  model: THolidayModel;
  procedure Callback(Sender: TObject);
  begin
    if Sender is THolidayModel then
      sgStatistic.Cells[2, 1] := 'Tage: ' + (Sender as THolidayModel).Ergebnis
    else
      sgStatistic.Cells[2, 1] := 'k. A.';
  end;

begin
  model := THolidayModel.Create;
  model.OnPropertyChanged := Callback;
  model.GetUrlaubsanspruchLfdJahr(Self.MainConfig.uri,
    Self.MainConfig.User.PersonalNr,
    Self.MainConfig.AppForLeaveConfig.ZaResturlaubId, YearOf(now));
end;

procedure THolidayNewForm.memReasonChange(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  if Length(memReason.Text) > 255 then
  begin
    memReason.Text := Copy(memReason.Text, 1, 255);
    MessageDLG('Der ''Grund'' darf nur 255 Zeichen lang sein!',
      mtWarning, [mbOK]);
  end;
end;

procedure THolidayNewForm.SetAbwList(const Value: TAbwList);
begin
  FAbwList := Value;
end;

procedure THolidayNewForm.SetFakStamp(const Value: TStampModel);
begin
  FFakStamp := Value;
end;

procedure THolidayNewForm.SetHoliday(const Value: THolidayModel);
begin
  FHoliday := Value;
  Self.cbbAbwFill;
end;

procedure THolidayNewForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  if Self.MainConfig.CommonConfig.WorkOrderTimes then
    Self.GetLastFakStamp;
  Self.WebFormResize(Self);
  Self.GetStatus;
  Self.sgStatisticInit;
  Self.Holiday := THolidayModel.Create;
end;

procedure THolidayNewForm.SetMask;
begin
  cbbAbw.ItemIndex := Self.AbwList.IndexOf(Self.Holiday.Abw.Id);
  if (cbbAbw.ItemIndex = -1) and (cbbAbw.Items.Count > 0) then
    cbbAbw.ItemIndex := 0;
  if Self.Holiday.Von > 0 then
    dtpVon.DateTime := Self.Holiday.Von
  else
    dtpVon.DateTime := Date + 1;
  if Self.Holiday.Bis > 0 then
    dtpBis.DateTime := Self.Holiday.Bis
  else
    dtpBis.DateTime := Date + 1;
  memReason.Text := Self.Holiday.Grund;
end;

procedure THolidayNewForm.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure THolidayNewForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure THolidayNewForm.WebFormResize(Sender: TObject);
var
  i, defaultColWidth: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Antragsstellung';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, true, pnlStatus,
        Self.MainConfig.User);
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Antragsstellung';
    if Self.MainConfig <> nil then
      SetStatusGrid(sgStatus, Stamp, FFakStamp, false, pnlStatus,
        Self.MainConfig.User);
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := 64;
  lblHeader.Width := pnlHeader.ClientWidth - btnBack.Width - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  i := Self.ClientHeight - pnlHeader.Height - pnlData.Height - pnlStatus.Height
    - pnlStatistic.Height;
  if pnlFooter.Visible then
    i := i - pnlFooter.Height;
  i := i div 2;
  if i < 0 then
    i := 0;
  pnlData.Top := pnlHeader.Height + pnlStatus.Height + i;
  i := (Self.ClientWidth - pnlData.Width) div 2;
  if i < 0 then
    i := 0;
  pnlData.Left := i;
  defaultColWidth := (sgStatistic.ClientWidth - sgStatistic.ColWidths[0] -
    24) div 7;
  for i := 1 to sgStatistic.ColCount - 1 do
    sgStatistic.ColWidths[i] := defaultColWidth;
end;

procedure THolidayNewForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  pnlStatus := TPanel.Create(Self);
  sgStatus := TStringGrid.Create(Self);
  pnlStatistic := TPanel.Create(Self);
  sgStatistic := TStringGrid.Create(Self);
  pnlData := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  cbbAbw := TComboBox.Create(Self);
  dtpVon := TDateTimePicker.Create(Self);
  dtpBis := TDateTimePicker.Create(Self);
  memReason := TMemo.Create(Self);
  btnSend := TBitBtn.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  pnlStatus.BeforeLoadDFMValues;
  sgStatus.BeforeLoadDFMValues;
  pnlStatistic.BeforeLoadDFMValues;
  sgStatistic.BeforeLoadDFMValues;
  pnlData.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  cbbAbw.BeforeLoadDFMValues;
  dtpVon.BeforeLoadDFMValues;
  dtpBis.BeforeLoadDFMValues;
  memReason.BeforeLoadDFMValues;
  btnSend.BeforeLoadDFMValues;
  try
    Name := 'HolidayNewForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnScroll', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UHolidayNewForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Antragsstellung';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UHolidayNewForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    pnlStatus.SetParentComponent(Self);
    pnlStatus.Name := 'pnlStatus';
    pnlStatus.Left := 0;
    pnlStatus.Top := 64;
    pnlStatus.Width := 640;
    pnlStatus.Height := 28;
    pnlStatus.Align := alTop;
    pnlStatus.Caption := 'pnlStatus';
    pnlStatus.ChildOrder := 2;
    pnlStatus.ShowCaption := False;
    sgStatus.SetParentComponent(pnlStatus);
    sgStatus.Name := 'sgStatus';
    sgStatus.Left := 0;
    sgStatus.Top := 0;
    sgStatus.Width := 640;
    sgStatus.Height := 28;
    sgStatus.Align := alClient;
    sgStatus.ColCount := 4;
    sgStatus.FixedCols := 0;
    sgStatus.RowCount := 2;
    sgStatus.FixedRows := 0;
    sgStatus.Font.Charset := ANSI_CHARSET;
    sgStatus.Font.Color := clNavy;
    sgStatus.Font.Height := -16;
    sgStatus.Font.Name := 'Segoe UI Semibold';
    sgStatus.Font.Style := [fsBold];
    sgStatus.Options := [goRangeSelect,goFixedRowDefAlign];
    sgStatus.ParentFont := False;
    sgStatus.ScrollBars := ssNone;
    sgStatus.TabOrder := 0;
    sgStatus.RangeEdit.Max := 100.000000000000000000;
    sgStatus.RangeEdit.Step := 1.000000000000000000;
    sgStatus.HeightPercent := 100.000000000000000000;
    sgStatus.WidthPercent := 100.000000000000000000;
    pnlStatistic.SetParentComponent(Self);
    pnlStatistic.Name := 'pnlStatistic';
    pnlStatistic.Left := 0;
    pnlStatistic.Top := 407;
    pnlStatistic.Width := 640;
    pnlStatistic.Height := 49;
    pnlStatistic.Align := alBottom;
    pnlStatistic.Caption := 'pnlStatistic';
    pnlStatistic.ChildOrder := 3;
    pnlStatistic.ShowCaption := False;
    sgStatistic.SetParentComponent(pnlStatistic);
    sgStatistic.Name := 'sgStatistic';
    sgStatistic.Left := 0;
    sgStatistic.Top := 0;
    sgStatistic.Width := 640;
    sgStatistic.Height := 49;
    sgStatistic.Align := alClient;
    sgStatistic.ColCount := 1;
    sgStatistic.FixedCols := 0;
    sgStatistic.RowCount := 1;
    sgStatistic.FixedRows := 0;
    sgStatistic.Options := [goFixedHorzLine,goHorzLine,goRangeSelect,goRowSelect,goFixedRowDefAlign];
    sgStatistic.TabOrder := 0;
    sgStatistic.RangeEdit.Max := 100.000000000000000000;
    sgStatistic.RangeEdit.Step := 1.000000000000000000;
    sgStatistic.SelectionTextColor := clBlack;
    sgStatistic.HeightPercent := 100.000000000000000000;
    sgStatistic.WidthPercent := 100.000000000000000000;
    pnlData.SetParentComponent(Self);
    pnlData.Name := 'pnlData';
    pnlData.Left := 8;
    pnlData.Top := 112;
    pnlData.Width := 273;
    pnlData.Height := 195;
    pnlData.Caption := 'pnlData';
    pnlData.ChildOrder := 4;
    pnlData.ShowCaption := False;
    WebLabel1.SetParentComponent(pnlData);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 13;
    WebLabel1.Width := 71;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Abwesenheit:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(pnlData);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 8;
    WebLabel2.Top := 39;
    WebLabel2.Width := 23;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'von:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(pnlData);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 8;
    WebLabel3.Top := 69;
    WebLabel3.Width := 18;
    WebLabel3.Height := 15;
    WebLabel3.Caption := 'bis:';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(pnlData);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 95;
    WebLabel4.Width := 36;
    WebLabel4.Height := 15;
    WebLabel4.Caption := 'Grund:';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    cbbAbw.SetParentComponent(pnlData);
    cbbAbw.Name := 'cbbAbw';
    cbbAbw.Left := 85;
    cbbAbw.Top := 8;
    cbbAbw.Width := 180;
    cbbAbw.Height := 23;
    cbbAbw.HeightPercent := 100.000000000000000000;
    cbbAbw.Text := 'cbbAbw';
    cbbAbw.WidthPercent := 100.000000000000000000;
    SetEvent(cbbAbw, Self, 'OnChange', 'cbbAbwChange');
    cbbAbw.ItemIndex := -1;
    dtpVon.SetParentComponent(pnlData);
    dtpVon.Name := 'dtpVon';
    dtpVon.Left := 85;
    dtpVon.Top := 36;
    dtpVon.Width := 180;
    dtpVon.Height := 22;
    dtpVon.BorderStyle := bsSingle;
    dtpVon.ChildOrder := 2;
    dtpVon.Color := clWhite;
    dtpVon.Date := 45426.606844710650000000;
    dtpVon.Role := '';
    dtpVon.Text := '';
    SetEvent(dtpVon, Self, 'OnChange', 'dtpVonChange');
    dtpBis.SetParentComponent(pnlData);
    dtpBis.Name := 'dtpBis';
    dtpBis.Left := 85;
    dtpBis.Top := 64;
    dtpBis.Width := 180;
    dtpBis.Height := 22;
    dtpBis.BorderStyle := bsSingle;
    dtpBis.ChildOrder := 2;
    dtpBis.Color := clWhite;
    dtpBis.Date := 45426.606844710650000000;
    dtpBis.Role := '';
    dtpBis.Text := '';
    SetEvent(dtpBis, Self, 'OnChange', 'dtpBisChange');
    memReason.SetParentComponent(pnlData);
    memReason.Name := 'memReason';
    memReason.Left := 85;
    memReason.Top := 92;
    memReason.Width := 180;
    memReason.Height := 40;
    memReason.HeightPercent := 100.000000000000000000;
    memReason.Lines.BeginUpdate;
    try
      memReason.Lines.Clear;
      memReason.Lines.Add('memReason');
    finally
      memReason.Lines.EndUpdate;
    end;
    memReason.SelLength := 0;
    memReason.SelStart := 0;
    memReason.WidthPercent := 100.000000000000000000;
    SetEvent(memReason, Self, 'OnChange', 'memReasonChange');
    btnSend.SetParentComponent(pnlData);
    btnSend.Name := 'btnSend';
    btnSend.Left := 85;
    btnSend.Top := 139;
    btnSend.Width := 160;
    btnSend.Height := 48;
    btnSend.Caption := 'Abschicken';
    btnSend.Color := clNone;
    btnSend.Glyph.LoadFromFile('UHolidayNewForm.pnlData.btnSend.Glyph.png');
    btnSend.GlyphSize := 32;
    btnSend.HeightPercent := 100.000000000000000000;
    btnSend.WidthPercent := 100.000000000000000000;
    SetEvent(btnSend, Self, 'OnClick', 'btnSendClick');
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    pnlStatus.AfterLoadDFMValues;
    sgStatus.AfterLoadDFMValues;
    pnlStatistic.AfterLoadDFMValues;
    sgStatistic.AfterLoadDFMValues;
    pnlData.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    cbbAbw.AfterLoadDFMValues;
    dtpVon.AfterLoadDFMValues;
    dtpBis.AfterLoadDFMValues;
    memReason.AfterLoadDFMValues;
    btnSend.AfterLoadDFMValues;
  end;
end;

end.
